import type { ExecuteWorkflowNodeRequest } from '@unifyapps/network/generated/models/executeWorkflowNodeRequest';
import type { ExecuteWorkflowNodeResponse } from '@unifyapps/network/generated/models/executeWorkflowNodeResponse';
import { executeFetch } from '@unifyapps/network/utils/fetch';

type FetchOptions = Parameters<typeof executeFetch>[1];

// Low-level POST to the public `/auth/workflow/execute/node` endpoint — the `/auth/…` (pre-auth,
// session-free) twin of `/api/workflow/execute/node`. Single source for the URL + verb + body shape,
// shared by the no-code runner's `executeAuthWorkflowNode` (which builds the query from debug params
// and forwards a debug `meta`) and the platform auth pages' `executeAuthNode` (which sends `?name=`
// plus `meta.isPublicPage` and narrows the response type). Each caller supplies its own query string,
// fetch `meta`, and abort signal so this stays a thin, behaviour-neutral wrapper.
export function postAuthWorkflowNode<TResponse = ExecuteWorkflowNodeResponse>(
  request: ExecuteWorkflowNodeRequest,
  searchParams: URLSearchParams,
  fetchOptions?: FetchOptions,
  signal?: AbortSignal,
): Promise<TResponse> {
  return executeFetch<TResponse>(
    {
      url: `/auth/workflow/execute/node?${searchParams.toString()}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: request,
      signal,
    },
    fetchOptions,
  );
}
